import { jdBlack, ThemeProvider } from "@deere/fuel-react";
import React from "react";
import ReactDOM from "react-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

ReactDOM.render(
  <Router>
    <React.StrictMode>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <meta name="msapplication-TileColor" content="#ffffff" />
          <meta name="theme-color" content="#ffffff" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="description" content="Transaction Pricing Application" />
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/black-favicon/apple-touch-icon.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/black-favicon/favicon-32x32.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href="https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/black-favicon/favicon-16x16.png"
          />
          <link
            rel="manifest"
            href="https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/black-favicon/site.webmanifest"
          />
          <link
            rel="mask-icon"
            href="https://cdn.ux.deere.com/brand-foundations/1.3.1/favicons/black-favicon/safari-pinned-tab.svg"
            color="#54585a"
          />
        </Helmet>
        <ThemeProvider theme={jdBlack} includeFonts={false}>
          <App />
        </ThemeProvider>
      </HelmetProvider>
    </React.StrictMode>
  </Router>,
  document.getElementById("root")
);

reportWebVitals();
